import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, RequiredValidator, Services, TextField } from '../../Components/Form';

const EditCategory = ({category, onSave, onClose}) => {
    return <Modal title="Edit Category" isOpen={!!category} setIsOpen={onClose} dismissible>

        <Form onSubmit={onSave} data={category} closeModalOnSubmit>
            <TextField name="name" label="Name" validators={[RequiredValidator]} />
            <TextField name="description" label="Description" validators={[RequiredValidator]} />
            <Services name="services" label="Services" />
            <Actions submit cancel />
        </Form>
    </Modal>
}


export default EditCategory;